import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { XAxisModule } from '../../axes/x-axis.module';
import { YAxisModule } from '../../axes/y-axis.module';
import { LineChartComponent } from './line-chart.component';

@NgModule({
   imports: [CommonModule, NgxChartsModule, PortalModule, XAxisModule, YAxisModule],
   declarations: [LineChartComponent],
   exports: [LineChartComponent],
})
export class LineChartModule {}
